import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { HomeComponent } from '../home/home.component';
import { AuthGuard } from './guards/auth/auth.guard';
import { NotAuthGuard } from './guards/not-auth/not-auth.guard';
import { RoleGuard } from './guards/role/role.guard';
import { AuthComponent } from './pages/auth/auth.component';
import { NotAuthorizedComponent } from './pages/not-authorized/not-authorized.component';
import { PageNotFoundComponent } from './pages/page-not-found/page-not-found.component';
import { GsisOauth2Component } from './pages/gsis-oauth2/gsis-oauth2.component';
import { SurgeriesPrivateComponent } from '../surgeries-private/surgeries-private.component';
import { SurgeriesAssignedComponent } from '../surgeries-assigned/surgeries-assigned.component';
import { SurgeriesIdikaComponent } from '../surgeries-idika/surgeries-idika.component';
import { ClinicComponent } from '../clinic/clinic.component';
import { HospitalAvailabilityComponent } from '../hospital-availability/hospital-availability.component';
import { UserComponent } from '../user/user.component';
import { SurgeriesCitizenComponent } from '../surgeries-citizen/surgeries-citizen.component';

const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', component: AuthComponent, canActivate: [NotAuthGuard] },
  {
    path: 'extlogin/:token',
    component: GsisOauth2Component,
    canActivate: [NotAuthGuard],
  },
  {
    path: 'newUserConfirmation',
    loadChildren: () =>
      import('../new-user-confirmation/new-user-confirmation.module').then(
        (m) => m.NewUserConfirmationModule
      ),
    canActivate: [NotAuthGuard],
  },
  {
    path: 'emailConfirmation',
    loadChildren: () =>
      import('../email-confirmation/email-confirmation.module').then(
        (m) => m.EmailConfirmationModule
      ),
    canActivate: [NotAuthGuard],
  },
  {
    path: 'home',
    loadChildren: () => import('../home/home.module').then((m) => m.HomeModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'user',
    loadChildren: () => import('../user/user.module').then((m) => m.UserModule),
    component: UserComponent,
    canActivate: [AuthGuard, RoleGuard],
    data: { roles: ['Admin'] },
  },
  {
    path: 'clinic',
    loadChildren: () =>
      import('../clinic/clinic.module').then((m) => m.ClinicModule),
    component: ClinicComponent,
    canActivate: [AuthGuard, RoleGuard],
    data: { roles: ['Admin'] },
  },
  {
    path: 'surgeries-idika',
    loadChildren: () =>
      import('../surgeries-idika/surgeries-idika.module').then(
        (m) => m.SurgeriesIdikaModule
      ),
    component: SurgeriesIdikaComponent,
    canActivate: [AuthGuard, RoleGuard],
    data: { roles: ['EkapyAdmin'] },
  },
  {
    path: 'surgeries-assigned',
    loadChildren: () =>
      import('../surgeries-assigned/surgeries-assigned.module').then(
        (m) => m.SurgeriesAssignedModule
      ),
    component: SurgeriesAssignedComponent,
    canActivate: [AuthGuard, RoleGuard],
    data: {
      roles: [
        'HospitalAdmin',
        'ClinicAdmin',
        'PrivateHospitalAdmin',
        'PrivateClinicAdmin',
        'ViewOnly',
      ],
    },
  },
  {
    path: 'surgeries-private',
    loadChildren: () =>
      import('../surgeries-private/surgeries-private.module').then(
        (m) => m.SurgeriesPrivateModule
      ),
    component: SurgeriesPrivateComponent,
    canActivate: [AuthGuard, RoleGuard],
    data: { roles: ['HospitalAdmin', 'ClinicAdmin'] },
  },
  {
    path: 'surgeries-citizen',
    loadChildren: () =>
      import('../surgeries-citizen/surgeries-citizen.module').then(
        (m) => m.SurgeriesCitizenModule
      ),
    component: SurgeriesCitizenComponent,
    canActivate: [AuthGuard, RoleGuard],
    data: { roles: ['Citizen'] },
  },
  {
    path: 'surgery',
    loadChildren: () =>
      import('../surgery/surgery.module').then((m) => m.SurgeryModule),
    canActivate: [AuthGuard, RoleGuard],
    data: {
      roles: [
        'EkapyAdmin',
        'HospitalAdmin',
        'ClinicAdmin',
        'PrivateHospitalAdmin',
        'PrivateClinicAdmin',
        'Citizen',
        'ViewOnly',
      ],
    },
  },
  {
    path: 'hospital-availability',
    loadChildren: () =>
      import('../hospital-availability/hospital-availability.module').then(
        (m) => m.HospitalAvailabilityModule
      ),
    component: HospitalAvailabilityComponent,
    canActivate: [AuthGuard, RoleGuard],
    data: {
      roles: ['HospitalAdmin', 'PrivateClinicAdmin', 'PrivateHospitalAdmin'],
    },
  },
  {
    path: 'contact',
    loadChildren: () =>
      import('../contact/contact.module').then((m) => m.ContactModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'page-not-found',
    component: PageNotFoundComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'not-authorized',
    component: NotAuthorizedComponent,
    canActivate: [AuthGuard],
  },
  {
    path: '*',
    component: HomeComponent,
    canActivate: [AuthGuard],
  },
  {
    path: '**',
    redirectTo: 'page-not-found',
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class CoreRoutingModule {}
